// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Brands_SectionIndex from "../Ouroboros.Models.Brands.SectionIndex/index.js";
import * as Ouroboros_Models_Brands_SectionTitle from "../Ouroboros.Models.Brands.SectionTitle/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_SectionID.eqSectionID);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_SectionIndex.eqSectionIndex);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var DocumentReviewAction = function (x) {
    return x;
};
var toLifecycleErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentReview (line 487, column 7 - line 489, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.lifecycleErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var toContentErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentReview (line 469, column 7 - line 471, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.contentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var sectionsMatch = function (a) {
    return function (b) {
        return eq(a.metadata.id)(b.metadata.id) || (eq1(a.metadata.index)(b.metadata.index) || a.metadata.name === b.metadata.name);
    };
};
var runUploadSupplementalDocument = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var runUploadSuccessToast = function (v) {
    return v;
};
var runSelectUploadPayload = function (v) {
    return v;
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runGenerateSectionQuestions = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var runFetchDocumentById = function (v) {
    return function (documentId) {
        return v(documentId);
    };
};
var runDownloadDocumentAsBlob = function (v) {
    return function (documentId) {
        return v(documentId);
    };
};
var runDocumentReviewAction = function (v) {
    return v;
};
var runAppendSection = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var readOption = function (v) {
    return v;
};
var resolveReviewRoute = function (env) {
    var fromRouteParam = Ouroboros_Services_Clients_Interop_Option.map(Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRouteWithDocument))(env.routeDocumentId);
    var documentIdOption = Ouroboros_Services_Clients_Interop_Option.map(function (v) {
        return v.id;
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v1) {
            return env.reviewRoute;
        })(identity)(fromRouteParam);
    })(function (documentId) {
        return Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRouteWithDocument)(documentId);
    })(documentIdOption);
};
var openModal = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(env.loading.setLoading), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.modalVisible))(true), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.newSectionTitle))(""), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.sectionTitleError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), runLoadingAction(env.loading.setSuccess) ]);
};
var mkDocumentReviewAction = DocumentReviewAction;
var missingUploadError = /* #__PURE__ */ (function () {
    var message = Ouroboros_Models_Core_ErrorHandlers.uploadErrorMessage("No file selected or missing section ID");
    return {
        message: message.message,
        info: message.info
    };
})();
var missingSelectionError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Select a section to interview first."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingDocumentError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document not loaded yet."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var isEmptySectionContents = function (maybeValue) {
    if (maybeValue instanceof Data_Maybe.Nothing) {
        return true;
    };
    if (maybeValue instanceof Data_Maybe.Just) {
        var normalized = Data_String_Common.trim(maybeValue.value0);
        return normalized === "" || (Data_String_CodeUnits.contains("hasn't been started")(normalized) || Data_String_CodeUnits.contains("has not been started")(normalized));
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentReview (line 196, column 3 - line 204, column 80): " + [ maybeValue.constructor.name ]);
};
var shouldPreferLocalSection = function (localSection) {
    return function (fetchedSection) {
        return isEmptySectionContents(fetchedSection.section_contents) && !isEmptySectionContents(localSection.section_contents);
    };
};
var mergeFetchedSection = function (localSections) {
    return function (fetchedSection) {
        var v = Data_Array.find(sectionsMatch(fetchedSection))(localSections);
        if (v instanceof Data_Maybe.Nothing) {
            return fetchedSection;
        };
        if (v instanceof Data_Maybe.Just) {
            var $67 = shouldPreferLocalSection(v.value0)(fetchedSection);
            if ($67) {
                return {
                    metadata: fetchedSection.metadata,
                    section_contents: v.value0.section_contents
                };
            };
            return fetchedSection;
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentReview (line 180, column 3 - line 186, column 23): " + [ v.constructor.name ]);
    };
};
var mergeFetchedDocument = function (localDocumentOption) {
    return function (fetchedDocument) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return fetchedDocument;
        })(function (localDocument) {
            return {
                name: fetchedDocument.name,
                id: fetchedDocument.id,
                document_contents: map(mergeFetchedSection(localDocument.document_contents))(fetchedDocument.document_contents)
            };
        })(localDocumentOption);
    };
};
var handleUploadSuccess = function (env) {
    return function (toast) {
        return function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runUploadSuccessToast(toast), runLoadingAction(env.loading.setSuccess) ]));
        };
    };
};
var handleLifecycleError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLifecycleErrorInput(errorValue))));
    };
};
var handleGenerateQuestionsSuccess = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.promptRoute)(response.probing_questions)), runLoadingAction(env.loading.setSuccess) ]));
    };
};
var handleFetchDocumentSuccess = function (env) {
    return function (fetchedDocument) {
        var mergedDocument = mergeFetchedDocument(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)))(fetchedDocument);
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(env.document))(mergedDocument), runLoadingAction(env.loading.setSuccess) ]));
    };
};
var handleDownloadSuccess = function (env) {
    return function (title) {
        return function (blob) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runBlobHandler(env.downloadHandler)(blob)(title)));
        };
    };
};
var handleContentError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toContentErrorInput(errorValue))));
    };
};
var handleAppendSectionSuccess = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(env.appendSectionState)(response.new_section), runNavigate(env.navigate)(resolveReviewRoute(env)), runLoadingAction(env.loading.setSuccess) ]));
    };
};
var fetchAndSetDocumentTask = function (env) {
    return function (routeDocumentId) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env))(handleFetchDocumentSuccess(env))(runFetchDocumentById(env.fetchDocumentById)(routeDocumentId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var fetchDocumentOnInitTask = function (env) {
    return function (routeDocumentId) {
        return fetchAndSetDocumentTask(env)(routeDocumentId);
    };
};
var downloadTask = function (env) {
    return Ouroboros_Services_Clients_Interop_Option.map(function (document) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env))(handleDownloadSuccess(env)(document.name))(runDownloadDocumentAsBlob(env.downloadDocumentAsBlob)(document.id));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/document_review_controller.md";
var closeModal = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(env.loading.setLoading), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.modalVisible))(false), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.sectionTitleError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), runLoadingAction(env.loading.setSuccess) ]);
};
var buildUploadRequest = function (payload) {
    return function (sectionId) {
        return {
            fileName: payload.fileName,
            file: payload.file,
            relation: payload.relation,
            section_id: sectionId
        };
    };
};
var handleUploadTask = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (payloadOption) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingUploadError)));
        })(function (payload) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (activeSectionOption) {
                return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                    return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingUploadError)));
                })(function (sectionId) {
                    return Ouroboros_Services_Clients_Interop_Task.chain(function (documentOption) {
                        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingUploadError)));
                        })(function (document) {
                            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleUploadSuccess(env)(env.uploadSuccessToast))(runUploadSupplementalDocument(env.uploadSupplementalDocument)(document.id)(buildUploadRequest(payload)(sectionId)));
                            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
                        })(documentOption);
                    })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)))));
                })(activeSectionOption);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.activeSection)))));
        })(payloadOption);
    })(runSelectUploadPayload(env.selectUploadPayload));
};
var buildOnInit = function (env) {
    return Ouroboros_Services_Clients_Interop_Option.map(function (routeDocumentId) {
        return Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(fetchDocumentOnInitTask(env)(routeDocumentId));
    })(env.routeDocumentId);
};
var buildGenerateRequest = function (sectionId) {
    return {
        section_id: sectionId
    };
};
var handleDraftTask = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (documentOption) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingSelectionError)));
        })(function (document) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (activeSectionOption) {
                return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                    return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingSelectionError)));
                })(function (sectionId) {
                    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleGenerateQuestionsSuccess(env))(runGenerateSectionQuestions(env.generateSectionQuestions)(document.id)(buildGenerateRequest(sectionId)));
                    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
                })(activeSectionOption);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.activeSection)))));
        })(documentOption);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)))));
};
var buildAppendSectionRequest = function (sectionTitle) {
    return {
        section_title: Ouroboros_Models_Brands_SectionTitle.makeSectionTitle(sectionTitle)
    };
};
var appendSectionTask = function (env) {
    return function (sectionTitle) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (documentOption) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingDocumentError)));
            })(function (document) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleAppendSectionSuccess(env))(runAppendSection(env.appendSection)(document.id)(buildAppendSectionRequest(sectionTitle)));
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
            })(documentOption);
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)))));
    };
};
var submitNewSectionTask = function (env) {
    return function (sectionTitle) {
        var $69 = Data_String_Common.trim(sectionTitle) === "";
        if ($69) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(env.sectionTitleError))("Section title is required"));
        };
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(closeModal(env));
        })(appendSectionTask(env)(sectionTitle));
    };
};
var mkDocumentReviewController = function (env) {
    return {
        onBack: mkDocumentReviewAction(runNavigate(env.navigate)(env.documentSelectionRoute)),
        onInit: buildOnInit(env),
        onOpenModal: mkDocumentReviewAction(openModal(env)),
        onDownload: Ouroboros_Services_Clients_Interop_Option.map(function (task) {
            return mkDocumentReviewAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(task));
        })(downloadTask(env)),
        handleDraft: mkDocumentReviewAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(handleDraftTask(env))),
        handleRefine: mkDocumentReviewAction(runNavigate(env.navigate)(env.refineRoute)),
        handleEdits: mkDocumentReviewAction(runNavigate(env.navigate)(env.finalEditsRoute)),
        handleUpload: mkDocumentReviewAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(handleUploadTask(env))),
        closeModal: mkDocumentReviewAction(closeModal(env)),
        handleSubmitNewSection: function (sectionTitle) {
            return mkDocumentReviewAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitNewSectionTask(env)(sectionTitle)));
        }
    };
};
export {
    DocumentReviewAction,
    mkDocumentReviewController,
    runDocumentReviewAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
